/**
 * Check if the current item is in the same level as the last item in the navigation stack
 * @param {String} parentId
 * @param {Object[]} navigationStack
 * @returns {Boolean}
 */
export const checkIsSameLevel = (parentId: string, navigationStack: [string, string][]) => {
	if (!navigationStack.length) {
		return false;
	}

	const lastItem = navigationStack[navigationStack.length - 1];
	const lastItemId = lastItem[0];

	// If the last item is the parent, it means we are going inside the same level
	if (lastItemId === parentId) {
		return false;
	}

	return true;
};
